import React from "react";
import Sidenav from "../components/Sidenav";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Navbar from "../components/Navbar";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import CardContent from "@mui/material/CardContent";
import GeoChart from "../charts/GeoChart";
import PieChart from "../charts/PieChart";
import BarChart from "../charts/BarChart";
import CountUp from "react-countup";

export default function Analytics() {
  return (
    <div className="bgcolor">
      <Navbar />
      <Box height={70} />
      <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" } }}>
        <Sidenav />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: { xs: 1, sm: 2, md: 3 },
            ml: { xs: "60px" }, // marginLeft only on sm and up
          }}
        >
          {/* Top Grid Row */}
          <Grid container spacing={2}>
            <Grid item xs={12} md={5}>
              <Grid container spacing={2}>
                {[
                  { value: 22000, delay: 0.2, className: "gradient" },
                  { value: 20000, delay: 0.3, className: "gradient" },
                  { value: 22000, delay: 0.4, className: "gradientlight" },
                  { value: 32000, delay: 0.5, className: "gradientlight" },
                ].map((item, index) => (
                  <Grid item xs={12} sm={6} key={index}>
                    <Card sx={{ height: "19vh" }} className={item.className}>
                      <CardContent>
                        <Typography
                          variant="body1"
                          sx={{ color: "#f0fcfc", pb: 1 }}
                        >
                          Visitors
                        </Typography>
                        <Typography variant="h5" sx={{ color: "#f0fcfc" }}>
                          <CountUp delay={item.delay} end={item.value} duration={0.5} />
                        </Typography>
                        <Typography variant="body2" sx={{ color: "#ccd1d1" }}>
                          Since last week
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Grid>

            {/* Bar Chart */}
            <Grid item xs={12} md={7}>
              <Card sx={{ height: { xs: "auto", md: "40vh" } }}>
                <CardContent>
                  <BarChart />
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {/* GeoChart and PieChart */}
          <Box height={16} />
          <Grid container spacing={2}>
            <Grid item xs={12} md={8}>
              <Card sx={{ height: { xs: "auto", md: "40vh" } }}>
                <CardContent>
                  <GeoChart />
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card sx={{ height: { xs: "auto", md: "40vh" } }}>
                <CardContent>
                  <PieChart />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </div>
  );
}
